(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("LEAH_Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["LEAH_Vue"], factory);
	else if(typeof exports === 'object')
		exports["configuration-app"] = factory(require("LEAH_Vue"));
	else
		root["configuration-app"] = factory(root["LEAH_Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 